// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1BOua","consentsList":"PatientConsents_consentsList__25AXr","consentsListEmpty":"PatientConsents_consentsListEmpty__1kVyV"};